import List from '../views/domains/list'
import Show from '../views/domains/show'

export default [
    {
        path: '/admin/domains',
        name: 'domains',
        component: List,
    },
    {
        path: '/admin/domain/:id',
        name: 'domain-show',
        component: Show,
    }
]
